export default __webpack_public_path__ + "static/media/file12.4995eaff.jpg";